import { hasFlag } from 'country-flag-icons';
import * as Flags from 'country-flag-icons/react/3x2';
import { InternalCountryFlagPlaceholder } from "../../internal";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Display's a country's flag given a 2-digit country code
 *
 * ## Accessibility ♿
 * - The country flag is hidden to screen readers by default, because we assume in most cases there is adjacent text making it a decorative image.  If there is no adjacent text, then an `aria-label` should be passed for screen readers.  Read more in the [Icon Accessibility](https://applyboard.atlassian.net/wiki/spaces/UE/pages/2402549963/Icon+Accessibility) confluence doc
 */
export function CountryFlag(_ref) {
  var ariaLabel = _ref['aria-label'],
    countryCode = _ref.countryCode;
  if (!hasFlag(countryCode)) {
    return _jsx(InternalCountryFlagPlaceholder, {
      value: countryCode
    });
  }
  var Flag = Flags[countryCode];
  return _jsx(Flag, {
    "aria-hidden": !ariaLabel,
    "aria-label": ariaLabel,
    "data-country-code": countryCode,
    role: "img",
    width: 24
  });
}